import TopTicker from "@/pages/home/components/TopTicker";
import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import UpdateStrip from "@/pages/home/components/UpdateStrip";
import TopicSection from "@/pages/home/components/TopicSection";
import ZoneSection from "@/pages/home/components/ZoneSection";
import ChannelSection from "@/pages/home/components/ChannelSection";
import NavSection from "@/pages/home/components/NavSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <header className="sticky top-0 z-50">
        <TopTicker />
        <SiteNav />
      </header>

      <main>
        <Hero />
        <UpdateStrip />
        <TopicSection />
        <ZoneSection />
        <ChannelSection />
        <NavSection />
        <DownloadSection />
      </main>

      <SiteFooter />
    </div>
  );
}